import styled from "@emotion/styled";

export const AccountSettingsPageContent = styled.div(({ theme }) => ({
	margin: "16px 20px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const AccountSettingsSearchWrapper = styled.div(({ theme }) => ({
	display: "flex",
	gap: "8px",
	div: {
		flex: 1
	},
	button: {
		width: "86px"
	}
}));
